var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('OrderInfo',{ref:"base",attrs:{"techCuttingCode":_vm.params.code,"disabled":_vm.isDisableEditForm}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }